var map = {
	"./layout.two-columns-2-1.html": 621,
	"./layout.two-equal-cols.html": 622,
	"./page.basic.html": 623,
	"./page.frontpage-parallax-full.html": 624
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;



//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets ^\.\/.*\.html$
// module id = 620
// module chunks = 0